import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosProjects: "AsbestosProject.AsbestosProjects",
  list: "AsbestosProject.AsbestosProjectList",
  // new: "AsbestosProject.AsbestosProjectNew",
  base: "AsbestosProject.AsbestosProjectBase",
  view: "AsbestosProject.AsbestosProjectView",
  // edit: "AsbestosProject.AsbestosProjectEdit",
  documents: "AsbestosProject.AsbestosProjectDocuments",
  documentsEdit: "AsbestosProject.AsbestosProjectDocumentsEdit",
  documentsNew: "AsbestosProject.AsbestosProjectDocumentsNew",
  notes: "AsbestosProject.AsbestosProjectNotes",
  noteEdit: "AsbestosProject.AsbestosProjectNoteEdit",
  noteNew: "AsbestosProject.AsbestosProjectNoteNew",
  asbestosInspectionsChildList: "AsbestosProject.AsbestosInspectionsChildList",
  asbestosNotificationsChildList: "AsbestosProject.AsbestosNotificationsChildList",
  audit: "AsbestosProject.AsbestosProjectAudit",
};

export { names as asbestosProjectRouteNames };

const asbestosProjectRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosProject",
    name: names.asbestosProjects,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Asbestos Projects",
          lookupGroups: ["AsbestosProjectType", "AsbestosNotificationFormType", "AsbestosProjectStatus"],
        },
        component: () => import("@/views/asbestosProjects/AsbestosProjectList.vue"),
      },
      // {
      //   path: "new",
      //   component: () => import("@/views/asbestosProjects/AsbestosProjectBase.vue"),
      //   redirect: { name: names.new },
      //   props: true,
      //   children: [
      //     {
      //       path: "",
      //       name: names.new,
      //       meta: { title: "New Asbestos Project", isNew: true },
      //       component: () => import("@/views/asbestosProjects/AsbestosProjectEdit.vue"),
      //     },
      //   ],
      // },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosProjects/AsbestosProjectBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Project View" },
            component: () => import("@/views/asbestosProjects/AsbestosProjectView.vue"),
          },
          // {
          //   path: "edit",
          //   name: names.edit,
          //   meta: { title: "Asbestos Project Edit", isForm: true },
          //   component: () => import("@/views/asbestosProjects/AsbestosProjectEdit.vue"),
          // },
          {
            path: "inspections",
            name: names.asbestosInspectionsChildList,
            meta: { title: "Inspections", lookupGroups: ["InspectionStatus", "InspectionType"] },
            component: () => import("@/views/asbestosProjects/AsbestosInspectionChildList.vue"),
          },
          {
            path: "notifications",
            name: names.asbestosNotificationsChildList,
            meta: {
              title: "Notifications",
            },
            component: () => import("@/views/asbestosProjects/AsbestosNotificationChildList.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Asbestos Project Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="asbestosProject" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Asbestos Project Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="asbestosProject" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Asbestos Project Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="asbestosProject" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Asbestos Project Notes" },
            component: {
              render: () => (
                <EntityNotes idField="asbestosProjectId" routeNamePrefix="AsbestosProject.AsbestosProjectNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Asbestos Project Note", isForm: true },
            component: () => import("@/views/asbestosProjects/AsbestosProjectNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Asbestos Project Note", isForm: true },
            component: () => import("@/views/asbestosProjects/AsbestosProjectNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Project Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="AsbestosProject" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosProjectRoutes;
